interface StepPretextProps {
  text: string
}

const StepPretext: React.FC<StepPretextProps> = ({ text }) => {
  return <div dangerouslySetInnerHTML={{ __html: text }} className="step-pretext" />
}

export default StepPretext;
